<template>
  <div>
    <header class="fixed-top" :class="{ 'border-bottom': menuIsOpen, 'is-scrolled': isScrolled }">
        <div class="container d-flex justify-content-between align-items-center">
            <HeaderLogo :menu-is-open="menuIsOpen" />

            <HeaderNav class="d-none d-lg-flex" />
            <HeaderButtons class="d-none d-lg-flex" />

            <div class="d-lg-none text-nowrap">
<!--                <BaseButton v-if="menuIsOpen" type="btn-secondary" to="/product#download-app">Get the App</BaseButton>-->

                <HeaderHamburgerButton :menu-is-open="menuIsOpen"/>
            </div>
        </div>
    </header>

    <HeaderMobileMenu :menu-is-open="menuIsOpen" />
    <Transition name="fade-down">
			<Modal v-if="appsDownloadModal" @closeModal="closeModal" @click.prevent>
				<template #category>Download Sport.Video app</template>

				<template #title>Download Sport.Video Filming App to start recording your games.</template>

				<template #content>
          <div class="d-flex justify-content-center w-100">
            <div class="d-flex gap-6 flex-column flex-md-row">
              <div class="d-flex flex-column gap-1">
                <div class="qr_back">
                    <img class="qr_bor" src="/static/images/apple_qr.png" alt="iosqr">
                </div>
                <a class="align-self-center" target="_blank" href="https://itunes.apple.com/sk/app/sport-video/id1241795100?mt=8"><img src="/static/images/appstore-badge.svg" alt=""/></a>
              </div>
              <div class="d-flex flex-column gap-1">
                <div class="qr_back">
                    <img class="qr_bor" src="/static/images/android_qr.png" alt="androidqr">
                </div>
                <a class="align-self-center" target="_blank" href="https://play.google.com/store/apps/details?id=com.sportvideo.android.recorder"><img src="/static/images/googleplay-badge.svg" alt=""/></a>
              </div>
            </div>
          </div>
        </template>
			</Modal>
    </Transition>
    </div>
</template>

<script>
export default {
    name: "MainHeader",
    data() {
        return {
            menuIsOpen: false,
            isScrolled: false,
            appsDownloadModal: false
        }
    },
    methods: {
      toggleMenu() {
        this.menuIsOpen = !this.menuIsOpen
      },
      closeModal() {
			  this.appsDownloadModal = false;
			  document.querySelector("html").classList.remove("modal-open");
		  },
    },
    mounted() {
       let self = this;
       window.addEventListener('scroll', function () {
        if (window.scrollY > 0)
          self.isScrolled = true
        else
          self.isScrolled = false
    })
      document.getElementById('app_download_modal_link').addEventListener('click', function ($event){
        $event.preventDefault();
        self.appsDownloadModal = true
      })
  },
}
</script>

<style lang="scss" scoped>
  .qr_back {
    background: #F5F6F8;
    width: 220px;
    height: 220px;
    padding: 24px;
    gap: 16px;
    border-radius: 16px;
  }
  .qr_bor {
    border: 2px solid #FA1F63;
    border-radius: 10px;
    max-height: 172px;
    max-width: 172px;
  }
</style>
